import React from 'react';
import {Provider} from 'react-redux';
import {renderElement} from '@Utils/root-element.util';
import type {AdminSaveSectionTemplatePanelProps} from '@Components/admin-save-section-template-panel/admin-save-section-template-panel';
import {AdminSaveSectionTemplatePanel} from '@Components/admin-save-section-template-panel/admin-save-section-template-panel';

window.PMW.mergePMW(PMW, {
  renderAdminSaveSectionTemplatePanel(containerElement: HTMLElement, opts: AdminSaveSectionTemplatePanelProps) {
    renderElement(
      containerElement,
      <Provider store={window.PMW.redux.store}>
        <AdminSaveSectionTemplatePanel {...opts} />
      </Provider>
    );
  },
});
